import type { ReactElement } from 'react';

export interface EmptyStateProps {
  /** The milestone that fills this in, e.g. "M2". */
  milestone: string;
  title: string;
  description: string;
  /** What this section will do once it exists. */
  points?: readonly string[];
}

export function EmptyState({ milestone, title, description, points }: EmptyStateProps): ReactElement {
  return (
    <section className="empty-state">
      <span className="badge badge--milestone">{milestone}</span>
      <h3 className="empty-state__title">{title}</h3>
      <p className="empty-state__description">{description}</p>
      {points !== undefined && points.length > 0 ? (
        <ul className="empty-state__points">
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
